import listComponent from './component.js';

let listModule = angular.module('listTpl', [
])
.component('listTpl', listComponent);

export default listModule;



/** WEBPACK FOOTER **
 ** ./src/template/list/index.js
 **/